import Decimal from "decimal";
import dayJs from "dayjs";
import { PAY_TYPE_MAP } from "../const/pay-type";
import { ls } from "../store/local-store";
import { THIRD_COMMON_LOGIN_APP_MAP } from "../const/config";
/**
 * 格式化时间
 * @param time
 * @param format
 * @return {string}
 */
export function formatTime(time, format) {
  return dayJs(time).format(format);
}

/**
 * 判断当前时间是否在某一时间段内（同天内）
 * @param from
 * @param to
 * @return {boolean}
 */
export function isTimeInSameDayRange(from, to) {
  let currTime = dayJs();
  let prefix = currTime.format("YYYY-MM-DD");
  let fromTime = dayJs(`${prefix} ${from}`);
  let toTime = dayJs(`${prefix} ${to}`);
  if (toTime.isBefore(fromTime)) {
    toTime = toTime.add(1, "day");
  }
  return (
    currTime.isAfter(fromTime, "minute") && currTime.isBefore(toTime, "minute")
  );
}

/**
 * 判断是否为微信环境
 * @return {boolean}
 */
export function isWX() {
  let lowerUa = navigator.userAgent.toLowerCase();
  return (
    lowerUa.match(/MicroMessenger/i) &&
    lowerUa.match(/MicroMessenger/i)[0] === "micromessenger"
  );
}

/**
 * 判断是否为小程序环境
 * @return {boolean}
 */
export function isMiniprogram() {
  return isWX() && window.__wxjs_environment === "miniprogram";
}

/**
 * 判断是否为支付宝环境
 * @return {boolean}
 */
export function isAlipay() {
  let ua = navigator.userAgent;
  return ua.indexOf("AlipayClient") !== -1 || ua.indexOf("AliApp") !== -1;
}

/**
 * 判断是否为苹果
 * @return {boolean}
 */
export function isIos() {
  return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}

/**
 * 判断是否为安卓
 * @return {boolean}
 */
export function isAndroid() {
  return (
    navigator.userAgent.indexOf("Android") > -1 ||
    navigator.userAgent.indexOf("Adr") > -1
  );
}

/**
 * 判断是否在车来了APP
 * @return {boolean}
 */
export function isChelaile() {
  return /Chelaile/i.test(navigator.userAgent);
}

/**
 * 是否佛山
 * @return {boolean}
 */
export function isFoShan(cityId) {
  return cityId === "019";
}

/**
 * 是否北京
 * @return {boolean}
 */
export function isBeiJing(cityId) {
  return cityId === "027";
}

 /**
	* 是否东莞
  */
 export function isDongGuan(cityId) {
	return cityId === '008';
 }
export function isNanNingApp() {
  const from = getUrlParams('from')
  const cityId = getUrlParams('cityId')
  return from === 'yunbaobao' && cityId === '046'
}

export function isThirdCommonLoginApp() {
  const from = getUrlParams('from')
  const cityId = getUrlParams('cityId')
  console.log('from', from, cityId)
  return THIRD_COMMON_LOGIN_APP_MAP[from] && THIRD_COMMON_LOGIN_APP_MAP[from](from, cityId)
}
/**
 * 是否快钱支付
 * @return {boolean}
 */
export function isKuaiQian(cityId) {
  const supportCity = isFoShan(cityId);
  return supportCity && (isWX() || isChelaile());
}

/**
 * 计算两数乘积
 * @param x
 * @param y
 * @return {number}
 */
export function numberTime(x, y) {
  return Number(new Decimal(x).mul(new Decimal(y)));
}

/**
 * 距离格式化
 * @param x
 * @return {{unit: (string), text: string}}
 */
export function formattedDistance(x) {
  let kilo = x > 1000;
  let text = kilo
    ? Number(new Decimal(x).div(new Decimal(1000))).toFixed(2)
    : Number(x).toFixed(2);
  let unit = kilo ? "公里" : "米";
  return {
    text,
    unit,
  };
}

/**
 * 延迟一段时间
 * @param {number} [timeout] - 延迟时长
 * @return {Promise<unknown>}
 */
export function wait(timeout = 260) {
  return new Promise((resolve) => {
    let timer = setTimeout(() => {
      clearTimeout(timer);
      timer = null;
      resolve();
    }, timeout);
  });
}

/**
 * 延迟执行
 * @param {Function} fn - 待执行函数
 * @param {number} [timeout] - 延迟时长
 */
export function delay(fn, timeout = 260) {
  let timer = setTimeout(() => {
    clearTimeout(timer);
    timer = null;
    return fn();
  }, timeout);
}

/**
 * 节流
 * @param fn
 * @param wait
 * @return {function(...[*]=)}
 */
export function throttle(fn, wait = 250) {
  let inThrottle, lastFn, lastTime;
  return function() {
    const context = this,
      args = arguments;
    if (!inThrottle) {
      fn.apply(context, args);
      lastTime = Date.now();
      inThrottle = true;
    } else {
      clearTimeout(lastFn);
      lastFn = setTimeout(function() {
        if (Date.now() - lastTime >= wait) {
          fn.apply(context, args);
          lastTime = Date.now();
        }
      }, Math.max(wait - (Date.now() - lastTime), 0));
    }
  };
}

/**
 * 防抖
 * @param fn
 * @param timeout
 * @return {function(...[*]=)}
 */
export function debounce(fn, timeout = 250) {
  let timer = null;
  return function() {
    const context = this;
    const args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(context, args);
    }, timeout);
  };
}

const PI = (3.14159265358979324 * 3000.0) / 180.0;

/**
 * 火星坐标（高德坐标）转百度坐标
 * @param lng
 * @param lat
 * @return {{lng: number, lat: number}}
 */
export function marsToBaidu(lng, lat) {
  let baiduPoint = { lng: 0, lat: 0 };
  let x = lng;
  let y = lat;
  let z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * PI);
  let theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * PI);
  baiduPoint.lng = z * Math.cos(theta) + 0.0065;
  baiduPoint.lat = z * Math.sin(theta) + 0.006;
  return baiduPoint;
}

/**
 * 百度坐标转火星坐标（高德坐标）
 * @param lng
 * @param lat
 * @return {{lng: number, lat: number}}
 */
export function baiduToMars(lng, lat) {
  let marsPoint = { lng: 0, lat: 0 };
  let x = lng - 0.0065;
  let y = lat - 0.006;
  let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * PI);
  let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * PI);
  marsPoint.lng = z * Math.cos(theta);
  marsPoint.lat = z * Math.sin(theta);
  return marsPoint;
}

/**
 * 轮询器
 * @param {Function|null|undefined} cb - 回调函数
 * @param {number} [timeout = 1000] - 轮询间隔
 * @return {{stop: stop, start: start}}
 * @constructor
 */
export function Looping(cb, timeout = 1000) {
  // 暂停标志
  let stopFlag = false;
  // 轮询注册表
  let loopingTimerMap = new Map();
  // 唯一轮询ID
  let loopingId = 0;
  // 开始轮询
  function start() {
    stopFlag = false;
    async function handler() {
      let id = loopingId++;
      if (stopFlag) {
        return;
      }
      if (loopingTimerMap.has(id)) return;
      let timer = setTimeout(async () => {
        if (stopFlag) {
          clearTimeout(timer);
          timer = null;
          return;
        }
        loopingTimerMap.set(id, timer);
        if (cb) {
          await cb();
          handler();
        }
      }, timeout);
    }
    handler();
  }
  // 结束所有轮询
  function stop() {
    stopFlag = true;
    loopingTimerMap.forEach((timer, id) => {
      if (timer) {
        clearTimeout(timer);
        timer = null;
        loopingTimerMap.delete(id);
      }
    });
  }
  return {
    start,
    stop,
  };
}

/**
 * 获取指北针夹角
 * @param {Function} onFulfilled
 * @return {{listener: listener, event: string}}
 * @constructor
 */
export function CompassHeading(onFulfilled) {
  let heading;
  let event = "deviceorientation";
  let listener = function(e) {
    let hasHeading = e.absolute;
    if (typeof e.webkitCompassHeading !== "undefined") {
      heading = e.webkitCompassHeading;
      hasHeading = true;
    } else {
      heading = 360 - e.alpha;
    }
    if (hasHeading) {
      onFulfilled && onFulfilled(heading);
    } else if (event === "deviceorientation") {
      window.removeEventListener(event, listener, false);
      event = "deviceorientationabsolute";
      window.addEventListener(event, listener, false);
    }
  };
  return {
    event,
    listener,
  };
}

// 脚本加载
export const loadScript = (name, url, once = false) =>
  new Promise((resolve) => {
    if (once && window[name]) {
      resolve(window[name]);
      return;
    }
    const script = document.createElement("script");
    script.type = "text/javascript";
    if (script.readyState) {
      // IE
      script.onreadystatechange = function onreadystatechange() {
        if (
          script.readyState === "loaded" ||
          script.readyState === "complete"
        ) {
          script.onreadystatechange = null;
          resolve(window[name]);
        }
      };
    } else {
      // Others
      script.onload = function onload() {
        resolve(window[name]);
      };
    }
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
  });

// 加载一次脚本
export const loadScriptOnce = (name, url) => loadScript(name, url, true);

export function getUrlParams(name) {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
        window.location.href
      ) || [undefined, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
}
export function getHashParam(key) {
  const hash = location.hash.split('?')[1];
  if (!hash) return undefined;

  const params = new URLSearchParams(hash);
  return params.get(key) || undefined;
}



// 获取支付方式
export function getPayType() {
  // 微信小程序支付
  if (isMiniprogram()) return PAY_TYPE_MAP.WX_MINIPROGRAM;
  // 快钱支付
  const cityId = ls.getItem("cityId");
  if (isKuaiQian(cityId)) {
    if (isChelaile()) {
      return PAY_TYPE_MAP.KUAI_QIAN_H5;
    } else {
      return PAY_TYPE_MAP.KUAI_QIAN_WX;
    }
  }
  // 公众号支付
  if (isWX()) return PAY_TYPE_MAP.WX;
  // 支付宝h5支付
  if (isAlipay()) return PAY_TYPE_MAP.ALIPAY;
  // 默认微信h5支付
  return PAY_TYPE_MAP.WX_H5;
}

// 格式化时间:  123 => 02分03秒
export function formatSeconds(seconds) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(
    remainingSeconds
  ).padStart(2, "0")}`;
}

export function deepCopy(data) {
  if (!data) return data;
  return JSON.parse(JSON.stringify(data));
}

export function fenToYuan(val) {
  if (typeof val === "string" || typeof val === "number") {
    return new Decimal(val).div(100).toNumber();
  }
  return val;
}

export function yuanToFen(val) {
  if (typeof val === "string" || typeof val === "number") {
    return new Decimal(val).times(100).toNumber();
  }
  return val;
}

export function minToHour(min) {
	if (typeof min === 'number' || typeof min === 'string') {
    const hour = new Decimal(min).div(60).toNumber()
		return Number.isInteger(hour) ? hour : hour.toFixed(1)
	}
	return min
}

export function dateToChinese(date, format = 'YYYY年M月D日') {
	return dayJs(date).format(format);
}

export function checkDate(date, showToday = true) {
  const today = dayJs();
  const tomorrow = dayJs().add(1, "day");
  const dayAfterTomorrow = dayJs().add(2, "day");
  if (today.isSame(date, "day")) {
    return showToday ? "今天" : "";
  } else if (tomorrow.isSame(date, "day")) {
    return "明天";
  } else if (dayAfterTomorrow.isSame(date, "day")) {
    return "后天";
  }
  return "";
}

export function deepClone(data) {
  return data ? JSON.parse(JSON.stringify(data)) : data;
}

export function getWebUrl(hash) {
	return encodeURIComponent(`${process.env.VUE_APP_FRONTEND_BASE_URL}${hash}`)
}

export function calcTimeDiff(time, timeFormat = 'HH:mm') {
	if (!time) return null;
	const dateFormat = 'YYYY-MM-DD';
	const now = dayJs().format(dateFormat);
	const targetTime = dayJs(`${now} ${time}`, `${dateFormat} ${timeFormat}`);
	const currentTime = dayJs();
	const diff = targetTime.diff(currentTime, 'minutes');
	if (Number.isNaN(diff) || diff <= 0) return null;
	if (diff < 60) return `${diff}分钟`;
	return `${minToHour(diff)}小时`;
}

export function setTitle(title) {
  try {
    if (title) {
      window.document.title = title
      return
    }
    let [source] = location.href.match(/source=[^&]*/) || [];
    if (source) {
      source = source.replace('source=', '');
    }
    if (source === 'mp') {
      document.title = '城际大巴车';
    } else {
      document.title = '网约巴士';
    }
    const cityId = getUrlParams('cityId') || ls.getItem("cityId");
    if (cityId === '021') {
      document.title = '优约巴士';
    }
    if (cityId === '008') {
      window.document.title = '随需公交'
    }
  } catch (e) {
    console.error(e);
  }
}